import { LoadingSpinner } from "../../components/common/LoadingSpinner";
import { checkoutCopy } from "../../i18n/checkout/es";
import { OrderSummarySection, PaymentMethodsSection } from "../../components/checkout";
import { useCheckoutState } from "../../state/checkout/useCheckoutState";
import styles from "./CheckoutPage.module.css";

export const CheckoutPage = () => {
    const {
        order,
        paymentMethods,
        selectedPaymentMethodCode,
        selectedPaymentMethod,
        paymentFormFields,
        paymentFormValues,
        voucherFile,
        selectPaymentMethod,
        updatePaymentFormValue,
        updateVoucherFile,
        completePayment,
        isLoading,
        isProcessing,
        loadError,
        actionError,
        exchangeRate,
        isRateLoading,
        rateError,
    } = useCheckoutState();

    if (isLoading) {
        return <LoadingSpinner label={checkoutCopy.order.loading} />;
    }

    if (loadError || !order) {
        return (
            <div className={styles.statusMessage} role="alert">
                {loadError ?? checkoutCopy.order.errorFallback}
            </div>
        );
    }

    return (
        <div className={styles.page} role="main">
            <div className={styles.layout}>
                <OrderSummarySection order={order} />
                <PaymentMethodsSection
                    paymentMethods={paymentMethods}
                    selectedPaymentMethodCode={selectedPaymentMethodCode}
                    selectedPaymentMethod={selectedPaymentMethod}
                    order={order}
                    paymentFormFields={paymentFormFields}
                    paymentFormValues={paymentFormValues}
                    voucherFile={voucherFile}
                    exchangeRate={exchangeRate}
                    isRateLoading={isRateLoading}
                    rateError={rateError}
                    onSelect={selectPaymentMethod}
                    onFieldChange={updatePaymentFormValue}
                    onVoucherChange={updateVoucherFile}
                    onSubmit={completePayment}
                    isProcessing={isProcessing}
                    actionError={actionError}
                />
            </div>
        </div>
    );
};
